var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftgrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9791 -1.80214e-06C19.0077 -1.97949e-06 21.0364 2.10447 21.0364 4.02985C21.0364 6.13433 17.817 9 15.9206 10.7463L34.1345 10.7463C37.4862 10.7463 38.5888 11.2388 39.3826 12.4925C39.7795 13.0746 40 13.9254 40 15C40 17.1493 39.1621 18.2687 37.7508 18.8507C37.0452 19.1194 35.8104 19.2537 34.1345 19.2537L15.9206 19.2537L18.0816 21.3582C19.2723 22.5224 20.0662 23.4179 20.4631 24.0896C20.86 24.7612 21.0364 25.3881 21.0364 25.9701C21.0364 27.8507 19.0518 30 16.9791 30C15.7883 30 14.5094 29.3284 12.7012 27.5373L2.50336e-06 15L12.4366 2.73134C14.5535 0.671641 15.7442 -1.69419e-06 16.9791 -1.80214e-06Z",
    fill: "#D9D4CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftgrey);
export default __webpack_public_path__ + "static/media/leftgrey.2263fedd86abeec77f30f96841e8ee16.svg";
export { ForwardRef as ReactComponent };